var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWork1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 382.98 302.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-10, .cls-11, .cls-13, .cls-12 {\n        stroke: #231f20;\n      }\n\n      .cls-1, .cls-4 {\n        fill: #fff;\n      }\n\n      .cls-1, .cls-7, .cls-8, .cls-11, .cls-13 {\n        stroke-width: .5px;\n      }\n\n      .cls-2, .cls-3, .cls-7, .cls-14, .cls-10, .cls-13 {\n        fill: #e6e7e8;\n      }\n\n      .cls-2, .cls-6, .cls-12 {\n        stroke-width: .75px;\n      }\n\n      .cls-3 {\n        opacity: .98;\n      }\n\n      .cls-3, .cls-9, .cls-10, .cls-15 {\n        stroke-width: .25px;\n      }\n\n      .cls-5 {\n        stroke-width: 2px;\n      }\n\n      .cls-5, .cls-9, .cls-11, .cls-15, .cls-12 {\n        fill: none;\n      }\n\n      .cls-6 {\n        fill: #bcbec0;\n      }\n\n      .cls-8 {\n        fill: #f1f2f2;\n      }\n\n      .cls-9, .cls-14, .cls-15 {\n        stroke: #010101;\n      }\n\n      .cls-14, .cls-15 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-13 {\n        stroke-linejoin: bevel;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m147.28,203.44L4.26,259.76c-2.21.87-4.01-.72-4.01-3.56V105.03c0-2.84,1.8-5.34,4.01-5.58l143.02-15.72c1.22-.13,2.21,1.45,2.21,3.55v111.51c0,2.09-.99,4.18-2.21,4.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m149.79,205.26L6.77,261.58c-2.21.87-4.01-.72-4.01-3.56V106.85c0-2.84,1.8-5.34,4.01-5.58l143.02-15.72c1.22-.13,2.21,1.45,2.21,3.55v111.51c0,2.09-.99,4.18-2.21,4.66Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "149.79 191.35 6.78 242.95 6.78 107.55 149.79 90.24 149.79 191.35"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 2.76,
    y1: 250.84,
    x2: 152,
    y2: 195.31
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m178.81,266.25l.07.13c.25.43.52.57-.07.88l-64.93,34.69c-.8.43-2.22.36-3.16-.15l-29.82-14.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m178.81,266.25l-64.93,34.69c-.8.43-2.22.36-3.16-.15l-29.82-16.27,68.42-31.91,28.92,12.38c.9.39,1.16.96.57,1.27Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "101.55 288.54 95.81 291.37 91.73 289.15 97.46 286.37 101.55 288.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "94.49 286.83 90.77 288.63 86.76 286.45 90.49 284.68 94.49 286.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "109.38 289.91 100.96 294.17 96.79 291.91 105.23 287.72 109.38 289.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "116.41 291.73 112.8 293.6 108.56 291.35 112.18 289.52 116.41 291.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "111.75 294.15 106.41 296.91 102.17 294.6 107.51 291.89 111.75 294.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "115.46 297.85 111.76 299.81 107.43 297.46 111.14 295.53 115.46 297.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "106.02 286.32 102.4 288.11 98.32 285.95 101.95 284.19 106.02 286.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "99.01 284.64 95.36 286.41 91.35 284.27 95.01 282.53 99.01 284.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "113.8 287.67 110.23 289.48 106.07 287.3 109.65 285.52 113.8 287.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "120.79 289.47 117.25 291.3 113.02 289.09 116.57 287.29 120.79 289.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "119.95 295.47 116.32 297.39 112 295.09 115.64 293.2 119.95 295.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "110.42 284.15 106.86 285.91 102.79 283.78 106.35 282.05 110.42 284.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "103.45 282.49 99.86 284.23 95.86 282.12 99.45 280.42 103.45 282.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "118.14 285.47 114.63 287.25 110.48 285.1 114 283.36 118.14 285.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "125.09 287.24 121.61 289.04 117.39 286.87 120.87 285.1 125.09 287.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "124.36 293.14 120.8 295.03 116.48 292.76 120.05 290.9 124.36 293.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "114.73 282.01 111.24 283.74 107.17 281.65 110.67 279.95 114.73 282.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "107.81 280.38 104.28 282.09 100.28 280.02 103.81 278.34 107.81 280.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "122.4 283.32 118.96 285.06 114.81 282.95 118.27 281.24 122.4 283.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "129.31 285.06 125.9 286.83 121.68 284.69 125.1 282.95 129.31 285.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "128.68 290.85 125.18 292.7 120.88 290.47 124.38 288.65 128.68 290.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "118.97 279.92 115.54 281.61 111.48 279.55 114.91 277.88 118.97 279.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "112.08 278.31 108.62 279.99 104.63 277.95 108.09 276.3 112.08 278.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "126.59 281.2 123.2 282.92 119.07 280.84 122.46 279.16 126.59 281.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "133.45 282.92 130.1 284.65 125.89 282.55 129.25 280.84 133.45 282.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "162 273.21 129.78 290.27 125.48 288.08 157.78 271.3 162 273.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "123.13 277.86 119.77 279.52 115.71 277.5 119.08 275.86 123.13 277.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "116.29 276.28 112.89 277.92 108.9 275.92 112.3 274.3 116.29 276.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "130.69 279.13 127.37 280.81 123.24 278.76 126.57 277.11 130.69 279.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "137.52 280.81 134.23 282.51 130.03 280.45 133.33 278.77 137.52 280.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "127.22 275.83 123.91 277.47 119.86 275.48 123.17 273.87 127.22 275.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "120.41 274.28 117.07 275.9 113.09 273.92 116.43 272.33 120.41 274.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "134.73 277.08 131.46 278.74 127.34 276.73 130.61 275.1 134.73 277.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "141.52 278.74 138.28 280.42 134.09 278.39 137.33 276.74 141.52 278.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "131.23 273.85 127.99 275.46 123.94 273.49 127.19 271.91 131.23 273.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "124.47 272.32 121.19 273.9 117.21 271.96 120.49 270.4 124.47 272.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "138.69 275.08 135.49 276.7 131.37 274.73 134.58 273.13 138.69 275.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "145.44 276.71 142.27 278.36 138.08 276.36 141.26 274.74 145.44 276.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "135.18 271.9 131.99 273.48 127.95 271.55 131.15 269.99 135.18 271.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "128.45 270.39 125.23 271.95 121.26 270.04 124.49 268.5 128.45 270.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "142.58 273.11 139.44 274.7 135.33 272.76 138.48 271.19 142.58 273.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "149.29 274.72 146.18 276.33 142 274.37 145.12 272.78 149.29 274.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "139.06 269.98 135.92 271.53 131.89 269.63 135.03 268.1 139.06 269.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "132.37 268.49 129.2 270.02 125.24 268.15 128.41 266.64 132.37 268.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "146.41 271.17 143.32 272.74 139.22 270.83 142.32 269.29 146.41 271.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "153.08 272.76 150.02 274.35 145.85 272.41 148.92 270.85 153.08 272.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "142.87 268.09 139.78 269.62 135.76 267.75 138.85 266.25 142.87 268.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "136.22 266.63 133.1 268.13 129.15 266.28 132.26 264.8 136.22 266.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "150.17 269.27 147.13 270.81 143.04 268.93 146.09 267.41 150.17 269.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "156.8 270.83 153.79 272.39 149.63 270.49 152.65 268.95 156.8 270.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "146.61 266.24 143.58 267.74 139.56 265.9 142.6 264.42 146.61 266.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "140 264.79 136.94 266.28 132.99 264.46 136.06 263 140 264.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "153.87 267.4 150.88 268.92 146.8 267.06 149.79 265.57 153.87 267.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "160.46 268.94 157.5 270.47 153.35 268.6 156.32 267.09 160.46 268.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "165.66 271.27 162.72 272.83 158.5 270.92 161.45 269.39 165.66 271.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "150.29 264.42 147.31 265.89 143.31 264.08 146.29 262.63 150.29 264.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "143.72 262.99 140.71 264.45 136.77 262.66 139.78 261.22 143.72 262.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "157.5 265.56 154.56 267.05 150.49 265.23 153.44 263.76 157.5 265.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "164.06 267.08 161.15 268.59 157.01 266.74 159.93 265.26 164.06 267.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "169.92 269.02 167.03 270.55 162.82 268.67 165.72 267.17 169.92 269.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "153.91 262.63 150.99 264.08 146.99 262.29 149.92 260.86 153.91 262.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "147.38 261.22 144.42 262.66 140.48 260.89 143.45 259.48 147.38 261.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "161.07 263.76 158.18 265.22 154.12 263.42 157.02 261.98 161.07 263.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "171.74 263.11 164.73 266.73 160.61 264.91 167.63 261.35 171.74 263.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "173.43 267.16 170.59 268.66 166.39 266.82 169.24 265.34 173.43 267.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "157.47 260.86 154.59 262.29 150.6 260.53 153.49 259.13 157.47 260.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "150.98 259.48 148.07 260.89 144.14 259.15 147.06 257.76 150.98 259.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "164.59 261.98 161.74 263.42 157.69 261.65 160.54 260.23 164.59 261.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "156.75 256.69 152 258.98 148.08 257.27 152.84 255.01 156.75 256.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "176.88 265.33 174.09 266.81 169.9 264.99 172.7 263.54 176.88 265.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "154.19 258.79 157.7 257.08 166.66 260.93 165.08 261.73 160.09 259.57 158.17 260.52 154.19 258.79"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 80.9,
    y1: 284.51,
    x2: 80.9,
    y2: 287.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 179.16,
    y1: 267.09,
    x2: 179.16,
    y2: 265.57
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-12",
    points: "88.65 253.87 104.86 246.67 104.86 248.05 88.65 255.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-12",
    points: "88.65 253.87 71.27 261.6 71.27 263.08 88.65 255.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m104.86,246.67l-32.51-10.91-21.16,8.61c-.35,1.42-.49,2.67.7,3.52l19.37,13.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m71.27,263.08l-20.04-14.35c-1.19-.85-1.74-2.34-1.38-3.76l.1-.39"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "44.54 148.27 39.99 131.37 48.95 129.8 44.54 148.27"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "25.96 125.04 26.02 151.58 42.29 148.18 42.23 119.17 40.78 119.39"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "24.59 123.55 24.66 150.16 41.01 146.8 40.95 117.71 27.31 119.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m27.24,126.5c0,.18-.11.34-.25.36s-.25-.1-.25-.28.11-.34.25-.36.25.1.25.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m27.24,129.8c0,.18-.11.34-.25.36s-.25-.1-.25-.28.11-.34.25-.36.25.1.25.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m27.19,139.7c0,.18-.11.34-.25.37s-.25-.09-.25-.27.11-.34.25-.37.25.1.25.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m27.26,136.39c0,.18-.11.34-.25.36s-.25-.1-.25-.27.11-.34.25-.36.25.1.25.27Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-13",
    points: "27.31 119.71 27.32 123.13 24.59 123.55 27.31 119.71"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "39.99 131.34 26.26 133.76 23.42 131.34 12.63 133.18 18.47 153.74 44.54 148.27 39.99 131.34"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "83.69 140.3 79.8 124.6 87.47 123.25 83.69 140.3"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "67.84 118.6 67.87 143.09 81.76 140.18 81.73 113.35 80.49 113.54"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "66.68 117.21 66.71 141.76 80.67 138.88 80.63 111.98 68.99 113.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m68.92,119.96c0,.16-.1.31-.21.33s-.22-.1-.22-.26.1-.31.22-.33.22.1.22.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m68.93,123c0,.16-.1.31-.21.33s-.22-.09-.22-.26.1-.31.22-.33.22.1.22.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m68.87,132.14c0,.16-.1.31-.21.33s-.22-.09-.22-.25.1-.31.22-.33.22.09.22.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m68.94,129.09c0,.16-.1.31-.21.33s-.22-.09-.22-.25.1-.31.22-.33.22.09.22.25Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-13",
    points: "68.99 113.69 69 116.84 66.68 117.21 68.99 113.69"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "79.8 124.58 68.09 126.64 65.67 124.38 56.51 125.94 61.46 144.97 83.69 140.3 79.8 124.58"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "46.46 193.28 41.94 176.86 50.83 174.52 46.46 193.28"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "28.03 171.76 28.09 198.16 44.22 193.38 44.17 164.52 42.73 164.87"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "26.67 170.4 26.74 196.86 42.95 192.11 42.9 163.18 29.37 166.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m29.29,173.11c0,.17-.11.34-.25.38s-.25-.08-.25-.25.11-.34.25-.38.25.08.25.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m29.3,176.39c0,.17-.11.34-.25.38s-.25-.08-.25-.25.11-.35.25-.38.25.08.25.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m29.24,186.24c0,.17-.11.35-.25.38s-.25-.07-.25-.25.11-.35.25-.39.25.07.25.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m29.32,182.94c0,.17-.11.35-.25.38s-.25-.07-.25-.25.11-.35.25-.38.25.07.25.25Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-13",
    points: "29.37 166.34 29.38 169.74 26.67 170.4 29.37 166.34"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "41.94 176.83 28.33 180.41 25.51 178.24 14.81 181 20.61 200.95 46.46 193.28 41.94 176.83"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "144.14 189.13 100.2 204.74 100.11 101.42 144.14 95.5 144.14 189.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m108.71,126.97c0,.6-.32,1.14-.71,1.22s-.71-.35-.71-.95.32-1.15.71-1.22.71.35.71.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m108.72,138.18c0,.6-.32,1.15-.71,1.24s-.71-.33-.71-.93.32-1.15.71-1.24.71.33.71.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m108.73,149.38c0,.6-.32,1.16-.71,1.25s-.71-.31-.71-.91.32-1.16.71-1.25.71.31.71.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m108.74,160.58c0,.6-.32,1.16-.71,1.27s-.71-.29-.71-.89.32-1.17.71-1.27.71.3.71.89Z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 120.28,
    y1: 111.9,
    x2: 129.89,
    y2: 110.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 113.03,
    y1: 126.14,
    x2: 139.01,
    y2: 121.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 113.04,
    y1: 137.24,
    x2: 139.01,
    y2: 131.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 113.04,
    y1: 147.48,
    x2: 139.01,
    y2: 141.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 113.05,
    y1: 159.43,
    x2: 139.01,
    y2: 152.53
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "365.4 289.66 306.73 289.66 306.73 253.32 347.29 253.32 365.4 289.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "361.73 286.66 306.73 286.66 306.73 255.82 346.9 255.91 361.73 286.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "361.73 284.82 306.73 284.82 306.73 253.99 346.9 254.08 361.73 284.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "361.73 282.99 306.73 282.99 306.73 252.16 346.9 252.24 361.73 282.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "361.73 281.1 306.73 281.1 306.73 250.27 346.9 250.35 361.73 281.1"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m361.75,279.83c-17.58-7.48-37.46-7.46-55.03.06v-30.83c12.83-5.47,26.89-6.93,40.39-4.39,4.98,11.18,9.89,22.9,14.63,35.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m308.97,275.06c14.61-5.67,30.65-6.25,45.55-1.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m308.97,268.8c13.95-5.41,29.21-6.19,43.54-2.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m308.43,264.74c13.22-5.26,27.65-6.33,41.36-3.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m308.97,258.52c12.21-4.74,25.43-5.93,38.14-3.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m308.97,254.39c11.43-4.44,23.74-5.76,35.7-3.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m308.97,251.39c11.08-4.3,22.99-5.68,34.6-4.13"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "248.06 289.66 306.73 289.66 306.73 253.32 266.17 253.32 248.06 289.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "251.73 286.66 306.73 286.66 306.73 255.82 266.56 255.91 251.73 286.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "251.73 284.82 306.73 284.82 306.73 253.99 266.56 254.08 251.73 284.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "251.73 282.99 306.73 282.99 306.73 252.16 266.56 252.24 251.73 282.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "251.73 281.1 306.73 281.1 306.73 250.27 266.56 250.35 251.73 281.1"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m251.71,279.83c17.58-7.48,37.46-7.46,55.03.06,0-10.28,0-20.56,0-30.83-12.83-5.47-26.89-6.93-40.39-4.39-4.98,11.18-9.89,22.9-14.63,35.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m304.49,275.06c-14.61-5.67-30.65-6.25-45.55-1.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m304.49,268.8c-13.95-5.41-29.21-6.19-43.54-2.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m305.03,264.74c-13.22-5.26-27.65-6.33-41.36-3.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m304.49,258.52c-12.21-4.74-25.43-5.93-38.14-3.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m304.49,254.39c-11.43-4.44-23.74-5.76-35.7-3.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m304.49,251.39c-11.08-4.3-22.99-5.68-34.6-4.13"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m306.65,281.1h.17c.81,0,1.47.66,1.47,1.47v4.08h-3.11v-4.08c0-.81.66-1.47,1.47-1.47Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 264.12,
    y1: 5.23,
    x2: 264.12,
    y2: 175.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 302,
    y1: 33.64,
    x2: 302,
    y2: 147.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 339.87,
    y1: 62.05,
    x2: 339.87,
    y2: 118.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 264.12,
    y1: 90.45,
    x2: 377.75,
    y2: 90.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 264.12,
    y1: 5.23,
    x2: 377.75,
    y2: 90.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 264.12,
    y1: 33.64,
    x2: 377.75,
    y2: 90.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 264.12,
    y1: 62.05,
    x2: 377.75,
    y2: 90.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 264.12,
    y1: 118.86,
    x2: 377.75,
    y2: 90.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 264.12,
    y1: 147.27,
    x2: 377.75,
    y2: 90.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 264.12,
    y1: 175.67,
    x2: 377.75,
    y2: 90.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 264.12,
    y1: 147.27,
    x2: 302,
    y2: 147.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 264.12,
    y1: 118.86,
    x2: 339.87,
    y2: 118.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 264.12,
    y1: 62.05,
    x2: 339.87,
    y2: 62.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 264.12,
    y1: 33.64,
    x2: 302,
    y2: 33.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 264.12,
    y1: 62.05,
    x2: 302,
    y2: 33.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 264.12,
    y1: 90.45,
    x2: 302,
    y2: 62.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 264.12,
    y1: 118.86,
    x2: 302,
    y2: 90.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 264.12,
    y1: 147.27,
    x2: 339.87,
    y2: 90.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 264.12,
    y1: 33.64,
    x2: 339.87,
    y2: 90.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 264.12,
    y1: 90.45,
    x2: 302,
    y2: 118.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 264.12,
    y1: 62.05,
    x2: 302,
    y2: 90.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 264.12,
    y1: 118.86,
    x2: 302,
    y2: 147.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 264.12,
    y1: 90.45,
    x2: 302,
    y2: 33.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 264.12,
    y1: 118.86,
    x2: 302,
    y2: 62.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 264.12,
    y1: 147.27,
    x2: 302,
    y2: 90.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 264.12,
    y1: 175.67,
    x2: 339.87,
    y2: 62.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 264.12,
    y1: 5.23,
    x2: 339.87,
    y2: 118.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 302,
    y1: 33.64,
    x2: 339.87,
    y2: 90.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 302,
    y1: 147.27,
    x2: 339.87,
    y2: 90.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 302,
    y1: 90.45,
    x2: 339.87,
    y2: 118.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 339.87,
    y1: 62.05,
    x2: 302,
    y2: 90.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 339.87,
    y1: 62.05,
    x2: 302,
    y2: 147.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 339.87,
    y1: 118.86,
    x2: 302,
    y2: 33.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 302,
    y1: 62.05,
    x2: 264.12,
    y2: 147.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 264.12,
    y1: 33.64,
    x2: 302,
    y2: 118.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 264.12,
    y1: 5.23,
    x2: 302,
    y2: 90.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 264.12,
    y1: 175.67,
    x2: 302,
    y2: 90.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 302,
    y1: 62.05,
    x2: 377.75,
    y2: 90.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 302,
    y1: 118.86,
    x2: 377.75,
    y2: 90.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 264.12,
    y1: 90.45,
    x2: 302,
    y2: 147.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 339.87,
    y1: 62.05,
    x2: 264.12,
    y2: 90.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 339.87,
    y1: 118.86,
    x2: 264.12,
    y2: 90.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 264.12,
    y1: 62.05,
    x2: 302,
    y2: 147.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 264.12,
    y1: 147.27,
    x2: 302,
    y2: 33.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 264.12,
    y1: 5.23,
    x2: 302,
    y2: 147.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 264.12,
    y1: 175.67,
    x2: 302,
    y2: 33.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 264.12,
    y1: 5.23,
    x2: 339.87,
    y2: 90.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 264.12,
    y1: 175.67,
    x2: 339.87,
    y2: 90.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 264.12,
    y1: 62.05,
    x2: 339.87,
    y2: 90.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 264.12,
    y1: 118.86,
    x2: 339.87,
    y2: 90.45
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 264.12,
    cy: 90.45,
    r: 4.73
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 264.12,
    cy: 62.05,
    r: 4.73
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 264.12,
    cy: 33.64,
    r: 4.73
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 264.12,
    cy: 5.23,
    r: 4.73
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 264.12,
    cy: 118.86,
    r: 4.73
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 264.12,
    cy: 147.27,
    r: 4.73
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 264.12,
    cy: 175.67,
    r: 4.73
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 377.75,
    cy: 90.45,
    r: 4.73
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 339.87,
    cy: 90.45,
    r: 4.73
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 339.87,
    cy: 62.05,
    r: 4.73
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 339.87,
    cy: 118.86,
    r: 4.73
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 302,
    cy: 90.45,
    r: 4.73
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 302,
    cy: 62.05,
    r: 4.73
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 302,
    cy: 118.86,
    r: 4.73
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 302,
    cy: 33.64,
    r: 4.73
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 302,
    cy: 147.27,
    r: 4.73
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWork1);
export default __webpack_public_path__ + "static/media/work1.fde50e9e4c3b59abbae0052ba2135424.svg";
export { ForwardRef as ReactComponent };